import {createDivIn, createImgIn, setElementInnerHTML} from '../../ui_utils/DomUtils'
import {LobbyImage} from '@colonist/types'
import {SocketDataTypes} from '../../../../../shared/SocketDataTypes'
import ILobbyRowPlayerData = SocketDataTypes.LobbyRowPlayerData
import {ColonistMembershipProduct, ColonistMembershipType} from '../../../../../shared/store/ColonistMembershipProduct'
import {getNestedTranslation, TranslationObject} from '@colonist/i18n'
import {createTooltipIn} from '../../ui_utils/TooltipUtils.ts'
import {uiManagerEvents} from '../../EntryShared.ts'

export class UILobbyTableRowPlayersController {
    private readonly players: HTMLDivElement

    constructor(container: HTMLTableCellElement, roomData: SocketDataTypes.LobbyRowData) {
        this.players = createDivIn(container, 'player_count')
        this.update(roomData.players, roomData.maxPlayers)
    }

    setOpacity(opacity: string) {
        this.players.style.opacity = opacity
    }

    update(players: ILobbyRowPlayerData[], maxPlayers: number, oldRoomData?: SocketDataTypes.LobbyRowData) {
        if(!UILobbyTableRowPlayersController.changedPlayerData(players, maxPlayers, oldRoomData)) return
        this.removePlayers()
        this.addRealPlayers(players)
        this.addHollowPlayers(maxPlayers - players.length)
    }

    private static changedPlayerData(players: ILobbyRowPlayerData[], maxPlayers: number, oldRoomData?: SocketDataTypes.LobbyRowData): boolean {
        if(oldRoomData == undefined) return true
        if(oldRoomData.maxPlayers != maxPlayers) return true
        if(oldRoomData.players.length != players.length) return true
        if(JSON.stringify(players) !== JSON.stringify(oldRoomData.players)) return true
        return false
    }

    private removePlayers() {
        setElementInnerHTML(this.players, {key: 'strings:colonistCommon.utils.emptyString'})
    }

    private addRealPlayers(players: ILobbyRowPlayerData[]) {
        for(const player of players) {
            const div = this.addPlayer(player.icon, undefined, player.membership)
            const karmaText: TranslationObject = ((player.karmaCompletedGames != undefined) && (player.karmaTotalGames != undefined)) ? {
                key: 'strings:homePage.header.playerKarma',
                options: {
                    totalCompleted: player.karmaCompletedGames,
                    totalGames: player.karmaTotalGames,
                },
            } : {key: 'strings:colonistCommon.utils.#buffer', options: {value: ''}}
            const hoverText = getNestedTranslation({key: 'strings:homePage.lobbyPage.playerHoverText'}, {
                username: {key: 'strings:colonistCommon.utils.#buffer', options: {value: player.username}},
                karmaText: karmaText,
            })
            if(!player.isBot) {
                createTooltipIn(div, hoverText)

                div.onclick = (event) => {
                    event.stopPropagation()
                    uiManagerEvents.openProfilePage(player.username)
                }
            }
        }
    }

    private addHollowPlayers(extraPlayerCount: number) {
        if(extraPlayerCount <= 0) return
        for(let i = 0; i < extraPlayerCount; i += 1) {
            this.addPlayer(LobbyImage.Guest, '0.5')
        }
    }

    private addPlayer(lobbyImg: LobbyImage, imgOpacity?: string, membership?: ColonistMembershipType): HTMLDivElement {
        const div = createDivIn(this.players, '', '')
        div.style.position = 'relative'
        const img = createImgIn(div, lobbyImg)
        if(imgOpacity) img.style.opacity = imgOpacity
        if(membership == undefined) return div
        const membershipProduct = ColonistMembershipProduct.getMembershipProduct(membership)
        if(membershipProduct == undefined) return div
        createImgIn(div, membershipProduct.lobbyImage, 'lobby_membership_icon')
        return div
    }
}
